module.exports = __webpack_public_path__ + "static/media/checkmark.f56e91bd.webp";